import React from 'react';

const Review = ({ review }) => {

    return (
        <div>
            <div className="chat chat-start">
                <div className="chat-image avatar">

                    {
                        review?.avatar ?
                            <div className="w-10 rounded-full">
                                <img alt='foodname' src={review.avatar} />
                            </div>
                            :
                            <div className="avatar placeholder">
                                <div className="bg-neutral-focus text-neutral-content rounded-full w-10">
                                    <span>{review.name.slice(0,2)}</span>
                                </div>
                            </div>
                    }

                </div>
                <div className="chat-header">
                    {review.name}
                </div>
                <div className="chat-bubble">{review.review}</div>
            </div>
            <div className="divider text-3xl"></div>
        </div>
    );
};

export default Review;